import { X, PenLine } from 'lucide-react';
import SellerSignatureEditor from './SellerSignatureEditor';
import { useSellerSigState } from '../../utils/sellerSignature';

/** „Můj podpis“ z menu uživatele – pro režim, kdy má každý uživatel svůj podpis (i role bez přístupu do Nastavení). */
export default function MySignatureModal({ onClose }: { onClose: () => void }) {
  const st = useSellerSigState();
  return (
    <div className="fixed inset-0 bg-black/60 z-[60] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xl flex flex-col max-h-[92vh]">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100 shrink-0">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 bg-blue-50 rounded-lg flex items-center justify-center"><PenLine className="h-4 w-4 text-blue-600" /></div>
            <div>
              <div className="font-semibold text-gray-900 text-sm">Můj podpis</div>
              <div className="text-xs text-gray-400">Vkládá se do smluv, které vytvoříte</div>
            </div>
          </div>
          <button onClick={onClose} className="p-1.5 hover:bg-gray-100 rounded-lg" aria-label="Zavřít"><X className="h-4 w-4 text-gray-400" /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-5">
          {st && st.mode === 'USER' && st.canUse ? (
            <SellerSignatureEditor scope="mine" current={st.mine} defaultName={st.mine.defaultName}
                                   nameLabel="Jméno u podpisu" namePlaceholder="např. Jan Novák, prodejce" />
          ) : (
            <p className="text-sm text-gray-500">Bazar teď používá jeden společný podpis, vlastní podpis nastavovat nemusíte.</p>
          )}
        </div>
        <div className="px-5 py-3 border-t border-gray-100 flex justify-end shrink-0">
          <button onClick={onClose} className="px-4 py-2 text-sm rounded-lg bg-gray-900 hover:bg-gray-700 text-white">Zavřít</button>
        </div>
      </div>
    </div>
  );
}
